import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import {Autocomplete, TextField }  from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useHistory } from "react-router-dom";

//For everyone playing along at home, this uses some different components than our other modals,
//but I kinda like this one.  Let's give a thumbs up/down to the different approaches and then
//come back and refactor for consistency

export default function FormDialog(props) {
    const [open, setOpen] = useState(false);
    const [name, setName] = useState();
    const [address, setAddress] = useState();
    const [protocol, setProtocol] = useState();
    const [connectivity, setConnectivity] = useState();

    const [allProtocols, setAllProtocols] = useState();
    const [allConnectivity, setAllConnectivity] = useState();
   

    useEffect(() => {
        if (props.selectedInterface) {
            setName(props.selectedInterface.name)
            setAddress(props.selectedInterface.address)
            setProtocol(props.selectedInterface.protocol)
            setConnectivity(props.selectedInterface.physical_connectivity)
        } else {
            setName(null)
            setAddress(null)
            setProtocol(null)
            setConnectivity(null)
        }
    }, [props.selectedInterface])

    useEffect(() => {
        setOpen(props.open)

        if (props.open && (!allProtocols || !allConnectivity)) {
            props.getAllProtocols().then(response => {
                setAllProtocols(response)
            })
    
            props.getAllPhysicalConnectionTypes().then(response => {
                setAllConnectivity(response)
            })
        }
    }, [props.open])

    const handleClose = () => {
        props.closeCallback();
    };

    const handleSubmit = () => {
        let i = { //Interface is a reserved word
            interface_id: props.selectedInterface ? props.selectedInterface.interface_id : null,
            name: name,
            address: address,
            site_id: props.siteId,
            protocol: protocol,
            physical_connectivity: connectivity
        }; 

        props.addOrUpdateInterfaceCallback(i).then(() => {
            props.closeCallback();
        })
    }

    return (
        <Dialog open={open} onClose={handleClose}>
            <DialogTitle>{props.selectedInterface ? "Update Communication Interface" : "Add Communication Interface"}</DialogTitle>
            <DialogContent>
                <div className="row-form-field">
                    <TextField id="name" label="Interface Name" variant="outlined" size="small" value={name || ''} fullWidth onChange={(e) => setName(e.target.value)} />
                </div>
                <div className="row-form-field">
                    <TextField id="address" label="IP Address or Web Address" variant="outlined" size="small" value={address || ''} fullWidth onChange={(e) => setAddress(e.target.value)} />
                </div>
                <div className="row-form-field">
                {
                    allProtocols ?
                    <Autocomplete
                        id="protocols"
                        options={allProtocols || []}
                        value={protocol}
                        renderInput={(params) => <TextField {...params} label="Protocol" variant="outlined" fullWidth size="small" />}
                        onChange={(event, newValue) => {
                            setProtocol(newValue);
                        }}
                    />
                    : null
                } 
                </div>
                <div className="row-form-field">
                {
                    allConnectivity ?
                    <Autocomplete
                        id="connectvity"
                        options={allConnectivity || []}
                        value={connectivity}
                        renderInput={(params) => <TextField {...params} label="Physical Connectivity" variant="outlined" fullWidth size="small" />}
                        onChange={(event, newValue) => {
                            setConnectivity(newValue);
                        }}
                    />
                    : null
                } 
                </div>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleSubmit}>Submit</Button>
            </DialogActions>
        </Dialog>
    )
}